function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
class CsvFormats {
  static fromExtension(fileName) {
    if (fileName.endsWith('.csv')) {
      return 'DEFAULT_CSV';
    }
    if (fileName.endsWith('.tsv') || fileName.endsWith('.tab')) {
      return 'TSV';
    }
    if (fileName.endsWith('.psv')) {
      return 'PIPE_SV';
    }
    return 'AUTODETECT';
  }
}
_defineProperty(CsvFormats, "DEFAULT_TYPE", 'DEFAULT_CSV');
_defineProperty(CsvFormats, "AUTO", 'AUTODETECT');
_defineProperty(CsvFormats, "TYPES", Object.freeze({
  DEFAULT_CSV: {
    name: 'Default csv (trimmed)',
    delimiter: ',',
    newline: undefined,
    // autodetect
    escapeChar: '"',
    shouldTrim: true,
    skipEmptyLines: true,
    nullString: '(null)'
  },
  TSV: {
    name: 'Tab seperated (tsv)',
    delimiter: '\t',
    newline: undefined,
    // autodetect
    escapeChar: '"',
    shouldTrim: true,
    skipEmptyLines: true,
    nullString: '(null)'
  },
  // From org.apache.commons.csv.CSVFormat#DEFAULT
  APACHE_COMMON_CSV: {
    name: 'Apache Common csv',
    delimiter: ',',
    newline: '\r\n',
    escapeChar: '"',
    shouldTrim: true,
    skipEmptyLines: true,
    nullString: null
  },
  // From org.apache.commons.csv.CSVFormat#EXCEL
  EXCEL_CSV: {
    name: 'Excel csv (strict)',
    delimiter: ',',
    newline: '\r\n',
    escapeChar: '"',
    shouldTrim: true,
    skipEmptyLines: false,
    nullString: null
  },
  // From org.apache.commons.csv.CSVFormat#MYSQL
  MY_SQL_CSV: {
    name: 'MySQL csv',
    delimiter: '\t',
    newline: '\n',
    escapeChar: '\\',
    shouldTrim: true,
    skipEmptyLines: false,
    nullString: '\\N'
  },
  // From org.apache.commons.csv.CSVFormat#RFC4180
  RFC4180_CSV: {
    name: 'RFC4180 csv',
    delimiter: ',',
    newline: '\r\n',
    escapeChar: '"',
    shouldTrim: true,
    skipEmptyLines: false,
    nullString: null
  },
  COLON_SV: {
    name: ': colon sv',
    delimiter: ':',
    newline: undefined,
    // autodetect
    escapeChar: '"',
    shouldTrim: true,
    skipEmptyLines: true,
    nullString: '(null)'
  },
  SEMI_COLON_SV: {
    name: '; semi-colon sv',
    delimiter: ';',
    newline: undefined,
    // autodetect
    escapeChar: '"',
    shouldTrim: true,
    skipEmptyLines: true,
    nullString: '(null)'
  },
  PIPE_SV: {
    name: '| pipe separated (psv)',
    delimiter: '|',
    newline: undefined,
    // autodetect
    escapeChar: '"',
    shouldTrim: true,
    skipEmptyLines: true,
    nullString: '(null)'
  },
  SPACE_SV: {
    name: '" " space sv',
    delimiter: ' ',
    newline: undefined,
    // autodetect
    escapeChar: '"',
    shouldTrim: true,
    skipEmptyLines: true,
    nullString: '(null)'
  },
  AUTODETECT: {
    name: 'autodetect',
    delimiter: undefined,
    // autodetect
    newline: undefined,
    // autodetect
    escapeChar: '"',
    shouldTrim: true,
    skipEmptyLines: true,
    nullString: '(null)'
  }
}));
export default CsvFormats;
//# sourceMappingURL=CsvFormats.js.map